/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientSessionRescheduleDto = {
    /**
     * Reschedule request UUID
     */
    id: string;
    /**
     * Old start time
     */
    oldStartTime: string;
    /**
     * Old end time
     */
    oldEndTime: string;
    /**
     * New start time
     */
    newStartTime?: string | null;
    /**
     * New end time
     */
    newEndTime?: string | null;
    /**
     * Reason for reschedule
     */
    reason?: string | null;
    /**
     * Reschedule status
     */
    status: ClientSessionRescheduleDto.status | null;
    /**
     * Requested at
     */
    requestedAt?: string | null;
};
export namespace ClientSessionRescheduleDto {
    /**
     * Reschedule status
     */
    export enum status {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        DECLINED = 'declined',
    }
}

